import { Fragment, useState } from 'react';

import * as Sentry from '@sentry/react';

import Grid from '@material-ui/core/Grid';

import { Form, Field, FormElement } from '@progress/kendo-react-form';
import { Input } from '@progress/kendo-react-inputs';
import { Button } from '@progress/kendo-react-buttons';

import { Auth } from 'aws-amplify';
import NewCognitoPasswordPrompt from '../NewCognitoPasswordPrompt/NewCognitoPasswordPrompt';

function CognitoSignOn(props) {
    const { backgroundProcessor, notificationCreate } = props;

    const [cognitoUser, setCognitoUser] = useState(null);

    const [newPasswordRequired, setNewPasswordRequired] = useState(false);

    const SignOnForm = () => (
        <Grid container direction="column" item style={{ paddingBottom: '1rem' }}>
            <Grid item>
                <FormElement>
                    <Grid container direction="column" >
                        <Grid container item direction="column" style={{ paddingBottom: '1rem' }}>
                            <Field
                                id="username"
                                name="username"
                                label="Username"
                                component={Input}
                                validator={(value) => {
                                    return (new RegExp(/\S+@\S+\.\S+/).test(value) && !value.includes('veolia.com')) ||
                                        new RegExp(/^\+44[0-9]+$/).test(value)
                                        ? ''
                                        : 'Username is invalid.';
                                }}
                            />

                        </Grid>

                        <Grid container item direction="column" style={{ paddingBottom: '2rem' }}>
                            <Grid item style={{ paddingBottom: '0.5rem' }}>
                                <Field
                                    id="password"
                                    name="password"
                                    label="Password"
                                    type="password"
                                    component={Input}
                                    validator={(value) => {
                                        return value ? '' : 'Password is invalid.';
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <Grid container item justifyContent="flex-end">
                            <Grid item>
                                <Button
                                    type="submit"
                                    iconClass="fas fa-id-badge"
                                    style={{ color: "white" }}
                                    look={"flat"}
                                    themeColor={"primary"}
                                    disabled={backgroundProcessor?.tasks}
                                >
                                    Sign-on
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </FormElement>
            </Grid>
        </Grid>
    );

    const authSignInHandler = async (credentials) => {
        backgroundProcessor?.add();

        const { username, password } = credentials;

        const result = await Auth.signIn(username, password);

        setCognitoUser(result);

        if (result.challengeName === 'NEW_PASSWORD_REQUIRED' || result.challengeName === 'FORCE_PASSWORD_CHANGE') {
            setNewPasswordRequired(true);
        } else {
            window.location.reload();
        }

        backgroundProcessor?.remove();
    };

    const formOnSubmitHandler = async (form) => {
        const { username, password } = form;

        if (!username || typeof username !== 'string') return;
        if (!password || typeof password !== 'string') return;

        try {
            await authSignInHandler({ username, password });
        } catch (error) {
            Sentry.captureException(error, { tags: { context: 'amplify', noFallback: true } });
        }
    };

    return (
        <Fragment>
            {newPasswordRequired && (
                <NewCognitoPasswordPrompt
                    backgroundProcessor={backgroundProcessor}
                    close={() => setNewPasswordRequired(false)}
                    notificationCreate={notificationCreate}
                    cognitoUser={cognitoUser}
                    success={async (userData) => {
                        const { username, newPassword } = userData

                        notificationCreate({
                            severity: 'success',
                            message: 'Your password has been updated successfully!',
                        });

                        await authSignInHandler({
                            username,
                            password: newPassword,
                        })
                    }}
                />
            )}

            <Form
                initialValues={{
                    username: '',
                    password: '',
                }}
                onSubmit={formOnSubmitHandler}
                render={SignOnForm}
            />
        </Fragment>
    );
}

export default CognitoSignOn;
